import { useNavigate } from 'react-router-dom';

const ExpresswayPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#f7f7f9] flex flex-col max-w-[480px] mx-auto">
      {/* Header */}
      <div className="bg-white px-4 pt-12 pb-4 flex items-center gap-3 border-b border-gray-50">
        <button
          onClick={() => navigate(-1)}
          className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-50 cursor-pointer"
        >
          <i className="ri-arrow-left-s-line text-gray-700 text-xl" />
        </button>
        <h1 className="font-bold text-gray-900 text-base">直通车</h1>
      </div>

      {/* Content */}
      <div className="flex-1 flex flex-col items-center justify-center px-8 pb-24">
        <div className="w-24 h-24 flex items-center justify-center rounded-3xl bg-gradient-to-br from-indigo-400 to-violet-500 mb-6">
          <i className="ri-roadster-line text-white text-5xl" />
        </div>
        <h2 className="text-gray-800 font-bold text-xl mb-3">直通车</h2>
        <p className="text-gray-400 text-sm text-center leading-relaxed mb-2">
          该功能正在开发中
        </p>
        <p className="text-gray-300 text-xs text-center">
          敬请期待，我们将尽快上线
        </p>

        <div className="mt-8 flex items-center gap-2 bg-amber-50 border border-amber-100 rounded-2xl px-5 py-3">
          <i className="ri-time-line text-amber-400 text-base" />
          <span className="text-amber-500 text-sm font-medium">功能开发中，即将上线</span>
        </div>
      </div>
    </div>
  );
};

export default ExpresswayPage;
